<template>
    <div id="games-mobile-widget" />
</template>

<script setup lang="ts">
    import { useScriptTag } from '@vueuse/core';
    import { getLaojingUrl } from '@/libraries/url';
    import { useWidgetStore } from '@/stores/widgetStore';

    const { preregisterWidget, unregisterWidget } = useWidgetStore();
    preregisterWidget('slots');
    preregisterWidget('footballStrike');
    preregisterWidget('miniGames');

    const { load } = useScriptTag(`${getLaojingUrl()}/mobile-widget.js`, undefined, { manual: true });
    load().catch(() => {
        unregisterWidget('slots');
        unregisterWidget('footballStrike');
        unregisterWidget('miniGames');
    });
</script>
